<template>
  <body class="program-body" id="partnerProgram">
    <div class="text">Partnership Program</div>
    <div class="boxes-wrapper">
      <router-link
        to="/partnershipProgram#forBrands"
        @click="handleScroll('#forBrands')"
        class="images image-one"
      >
        <div class="text-box text-box-one">
          <a>For Brands </a>
        </div>
      </router-link>
      <router-link
        to="/partnershipProgram#forInfluencers"
        @click="handleScroll('#forInfluencers')"
        class="images image-two"
      >
        <div class="text-box text-box-one">
          <a>For Influencers </a>
        </div>
      </router-link>
    </div>
  </body>
</template>

<script>
import { nextTick } from "vue";

export default {
  name: "PartnersProgram",
  methods: {
    handleScroll(hash) {
      if (this.$route.path !== "/partnershipProgram") {
        this.$router.push(`/partnershipProgram${hash}`).then(() => {
          nextTick(() => {
            this.scrollToHash(hash);
          });
        });
      } else {
        this.scrollToHash(hash);
      }
    },
    scrollToHash(hash) {
      const validHash = hash.startsWith("#") ? hash : `#${hash}`;
      nextTick(() => {
        const element = document.querySelector(validHash);
        if (element) {
          const elementPosition =
            element.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition,
            behavior: "smooth",
          });
        } else {
          console.warn(`Element with ID ${validHash} not found!`);
        }
      });
    },
  },
};
</script>

<style scoped>
.program-body {
  width: 100%;
  height: 654px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 45px;
}
.text {
  font-size: 45px;
  font-weight: 600;
  line-height: 1.2;
  max-width: 400px;
  text-align: center;
}
.boxes-wrapper {
  display: flex;
  gap: 20px;
}

.images {
  width: 425px;
  height: 210px;
  border-radius: 20px;
  cursor: pointer;
}

.image-one {
  background-image: url("../../../assets/sustainability/difference.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.image-two {
  background-image: url("../../../assets/background.jpeg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center 20%;
}
.text-box {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.text-box-one {
  background: rgba(0, 0, 0, 0.5);
}

.text-box-one:hover {
  background: linear-gradient(
      to right,
      rgba(249, 129, 64, 0.5),
      rgba(235, 77, 191, 0.5)
    ),
    rgba(0, 0, 0, 0.2);
}
a {
  font-size: 30px;
  font-weight: 500;
  color: #ffffff;
}

@media (max-width: 1024px) {
  .program-body {
    height: 591px;
  }
  .text {
    font-size: 40px;
  }
  .images {
    width: 360px;
    height: 160px;
  }
}
@media (max-width: 744px) {
  .text {
    font-size: 30px;
    max-width: 178px;
  }
  .program-body {
    height: 396px;
  }
  .boxes-wrapper {
    display: flex;
    gap: 12px;
  }
  .images {
    width: 261px;
    height: 119px;
    font-size: 20px;
  }
}
@media (max-width: 588px) {
  .program-body {
    height: 567px;
  }
  .boxes-wrapper {
    display: flex;
    flex-direction: column;
  }
}
</style>
